'use client';

import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

import { Button } from '@/app/components/button';
import { IconMyLocation } from '@/app/components/icons/maps/icon-my-location';
import { IconAdd } from '@/app/components/icons/ui-actions/icon-add';
import { IconRemove } from '@/app/components/icons/ui-actions/icon-remove';
import { MAP_DEFAULT } from '@/app/components/shared/dealer/utils/dealer-constant';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface MapControlsDesktopProps {
  onClickCurrentLocation: () => void;
  currentLocation: google.maps.LatLngLiteral | null;
}

export const MapControlsDesktop = ({
  currentLocation,
  onClickCurrentLocation,
}: MapControlsDesktopProps) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !currentLocation) return;

    map?.panTo(currentLocation);
    map?.setZoom(MAP_DEFAULT.ZOOM_SELECTED_DEALER);
  }, [currentLocation, map]);

  const getZoom = () => map?.getZoom() ?? 15;

  const onZoomIn = () => {
    map?.setZoom(getZoom() + 1);
  };

  const onZoomOut = () => {
    if (getZoom() === 4) return;
    map?.setZoom(getZoom() - 1);
  };

  if (!map) return null;

  return (
    <div className="absolute right-8 bottom-4 z-20 hidden flex-col gap-y-2 xl:flex">
      <Button
        onClick={onClickCurrentLocation}
        color="black"
        aria-label="Current Location"
        iconBefore={<IconMyLocation />}
        size="sm"
        {...createDataAttributes({ test: 'current-location' })}
      />
      <Button
        color="white"
        aria-label="Zoom In"
        iconBefore={<IconAdd />}
        onClick={onZoomIn}
        size="sm"
        {...createDataAttributes({ test: 'zoom-in' })}
      />
      <Button
        color="white"
        aria-label="Zoom Out"
        iconBefore={<IconRemove />}
        onClick={onZoomOut}
        disabled={getZoom() === 4}
        size="sm"
        {...createDataAttributes({ test: 'zoom-out' })}
      />
    </div>
  );
};
